<template>
  <div class="loading" v-show="isShow.isLDShow">
    <div class="animation">

      <div class="ratio">{{ loadingNum }}%</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    isShow: {
      type: Object,
    },
  },
  data() {
    return {
      loadingNum: 0,
      imgArr: [],
      isRunningShow: true,
      preLoadImg: [
        { src: require('./img/off.png') },
      ],
    };
  },
  computed: {
    transX() {
      return 3.02 * this.loadingNum;
    },
    humanTransX() {
      return 1.4 * this.loadingNum;
    },
  },
  methods: {
    generateId(index) {
      return `mImg${index}`;
    },
    go() {
      this.isShow.isLDShow = false;
      this.isShow.isKVShow = true;
    },
    loadNextImg(imgID) {
      const _this = this;
      const len = this.preLoadImg.length;
      const curSrc = this.preLoadImg[imgID].src;
      const curImg = new Image();
      curImg.onload = function () {
        imgID++;
        _this.loadingNum = parseInt(imgID / len * 100);
        if (imgID < len) {
          _this.loadNextImg(imgID);
        } else {
          _this.isRunningShow = false;
          setTimeout(() => {
            _this.go();
          }, 600);
        }
      };
      curImg.src = curSrc;
    },
  },
  mounted() {
    const imgID = 0;
    setTimeout(() => {
      this.loadNextImg(imgID);
    }, 1000);
  },
};
</script>

<style lang="scss" scoped>
.loading {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  .animation {
    position: relative;
    // margin-bottom: 5rem /* 80/16 */;

    .ratio {
      margin-top: 1.25rem /* 20/16 */;
      text-align: center;
      color: #333;
      font-size: .875rem /* 14/16 */;
    }
  }
}

.human-run {
  animation: run steps(1, end) .6s infinite;
}

@keyframes run {
  0% {
    background-position: 0 0;
  }
  25% {
    background-position: -67.5px 0;
  }
  50% {
    background-position: -135px 0;
  }
  75% {
    background-position: -202.5px 0;
  }
  100% {
    background-position: -270px 0;
  }
}

.slideIn {
  animation: slideIn .01s ease-in;
  animation-fill-mode: both;
}

@keyframes slideIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
